export default __webpack_public_path__ + "static/media/node.87117bff.png";